export function noop() {
    // This function is intentionally empty.
}
